import { render, staticRenderFns } from "./withdraw_status.vue?vue&type=template&id=df81fc02&scoped=true&"
import script from "./withdraw_status.vue?vue&type=script&lang=js&"
export * from "./withdraw_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df81fc02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df81fc02')) {
      api.createRecord('df81fc02', component.options)
    } else {
      api.reload('df81fc02', component.options)
    }
    module.hot.accept("./withdraw_status.vue?vue&type=template&id=df81fc02&scoped=true&", function () {
      api.rerender('df81fc02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/withdraw_status.vue"
export default component.exports